module.exports = __webpack_public_path__ + "fonts/838c598.otf";